import { render } from "./weeklyRankRewardsAgency.vue?vue&type=template&id=b614c2b8"
import script from "./weeklyRankRewardsAgency.vue?vue&type=script&lang=js"
export * from "./weeklyRankRewardsAgency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__